export default "__VITE_ASSET__2fxqbUY5__"